import React, { Component } from 'react';
// import { browserHistory } from 'react-router';
// import { connect } from 'react-redux';
// import { asyncConnect } from 'redux-connect';
import _ from 'lodash';
import Link from '../../../../../components/ZUILib/Link';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ApplyCSS from '../../../../../components/ApplyCSS';
import VerificationPanel from '../RetiroAnticipado/verificationPanel';
import commonUtil from '../../../../../utils/commonUtil';
// import { constDownload, constPrint } from '../../../../../utils/clientConstant';
// import * as labelsActions from '../../../../../components/labels/actions';
// import * as typeActions from '../../actions';
// import AppEvents from '../../../../App/AppEvents';

// const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'partialTransference';
const pageNameWAP = 'partialTransferenceWAP';
// const { saveBankOrCardDetails, sendMail } = typeActions;
// const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
const brand = commonUtil.getBrand();
const constChannels = commonUtil.getClientConstForChannel();

export default class PartialConfirmationRender extends Component {
  render() {
    const Guardar = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      style: 'btnSecondary size-Full',
      onClickHandler: this.props.saveCard,
      id: 'save',
      disabled: this.props.isGuardar,
    };
    const eventAdministrationRedirect = {
      name: 'Ir a Mesa de regalos',
      type: 'button',
      value: 'Ir a Mesa de Regalos',
      autoFocus: false,
      style: 'btnPrimary size-Large',
      onClickHandler: this.props.redirectToAdministration,
      id: 'eventAdministrationRedirect',
    };
    const eventAdministrationRedirectLink = {
      text: 'Ir a Mesa de Regalos',
      children: 'Ir a Mesa de Regalos',
      href: '',
      cssStyle: {
        borderRadius: '4px',
      },
      cssClass: 'btnPrimary size-Full giftListRedirectLink',
      onClickHandler: this.props.redirectToAdministration,
    };
    const downloadFile = {
      route: '',
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.props.emailSendClick(); },
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ eWalletCreatedMessage: null, savedCardConfirmation: null }); },
    };


    return (
      <div className="toPrint">
        {!_.isEmpty(this.props.submitData) && !_.isEmpty(this.props.lables) ?
          <React.Fragment>
            {channel === constChannels.WAP ?
              <React.Fragment>
                <ApplyCSS pageName={pageNameWAP} />
                <div className="row" style={{ backgroundColor: '#FFFFFF' }}>
                  <div className="col-xs-12 innerOptions">
                    <h2
                      className="subtitleSection title-confirmation"
                      style={{ textAlign: 'center' }}
                    >
                      Confirmación de retiro anticipado de mesa de regalos
                    </h2>
                    <p><span style={{ color: '#333333' }}>Fecha de operación &nbsp;</span>{this.props.submitTransferenceData && commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}</p>
                  </div>

                  <div>
                    {this.props.submitTransferenceData &&
                      <React.Fragment>
                        <VerificationPanel
                          isEmployee={this.props.isEmployee}
                          user={this.props.user}
                          submitTransferenceData={this.props.submitTransferenceData}
                          loadFrom="partialConfirmation"
                        />
                      </React.Fragment>
                    }
                  </div>

                  <div className="col-xs-12 innerOptions">
                    {this.props.eWalletCreatedMessage ? <div className="alertSuccess"><i className="icon-check" />
                      <p>{this.props.eWalletCreatedMessage ? this.props.eWalletCreatedMessage : null} </p>
                      <Link linkJSON={errorAncher} />
                      <small>Puedes consultar tu tu monedero en la sección<b>
                        Mis monederos &nbsp;de tu cuenta Liverpool, o haciendo &nbsp;</b><a className="text-pink" href="#">click aqui</a></small>
                    </div>
                      : null}
                  </div>

                  {this.props.emailSendStatus ?
                    <div className="col-xs-12">
                      {this.props.emailSendStatus.isSent ?
                        <div className="alertSuccess" > <i className="icon-check" />
                          <p>{this.props.emailSendStatus.resMsg}</p>
                          <Link linkJSON={emailSendLink} />
                        </div> :
                        <div className="alertError" > <i className="icon-tache2" />
                          <p>{this.props.emailSendStatus.resMsg}</p>
                          <Link linkJSON={emailSendLink} />
                        </div>}
                    </div> : null}

                  <div className="col-xs-12">
                    {
                      this.props.isEmployee !== 'true' ?
                        <React.Fragment>
                          <p>{commonUtil.getLabel(this.props.lables.closeTableAdmin, 'email.giftClosingInfo.transferInfo1')}
                            {(this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== 'undefined' && this.props.submitTransferenceData.walletType == 'Monedero Digital') &&
                            <React.Fragment><br />{commonUtil.getLabel(this.props.lables['transference success page'], 'email.dwallet.giftClosingInfo.transferInfo1')}</React.Fragment>
                    }</p>
                          <hr />
                        </React.Fragment>
                    : null
                    }

                    {
                      this.props.savedCardConfirmation ? <div className="alertSuccess"><i className="icon-check" />
                        <p>{this.state.savedCardConfirmation ? this.props.savedCardConfirmation : null}</p>
                        <Link linkJSON={errorAncher} />
                      </div> : null
                      /* eslint-enable */
                    }
                    <p>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label1')} &nbsp;
                      <strong>{this.props.submitData.emailAddress}</strong>,&nbsp;
                      {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label2')}
                    </p>
                    {
                       this.props.isEmployee !== 'true' ?
                         <p>
                           {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label3')}
                           <strong>
                             {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label4')}
                           </strong>
                         </p>
                    : <p>Recuerda conservar tu <strong>número de evento para el seguimiento</strong></p>
                    }

                  </div>

                  <div className="col-xs-12">
                    {this.props.submitData && this.props.submitData.enableSaveButton && this.props.submitData.enableSaveButton.toString() === 'true' ?
                      <div>
                        <p className="mainText">{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.savemessage')}</p><InputButton buttonAttr={Guardar} />
                      </div> : null}
                    {!this.props.printAndDownload ?
                      <div className="col-xs-12">
                        <div className="row">
                          <Link linkJSON={eventAdministrationRedirectLink}>Ir a Mesa de Regalos</Link>
                        </div>
                      </div> : null}
                  </div>
                </div>
              </React.Fragment>
              : <div className="container">
                <ApplyCSS pageName={pageName} />
                <div className="toPrint" id="partialConfirmation" style={{ backgroundColor: '#FFFFFF' }}>
                  <div className="row step3">
                    <div className="col-xs-12">
                      <div className="row">
                        <div className="col-xs-12">
                          {
                            /* eslint-disable */
                            this.props.eWalletCreatedMessage || this.props.savedCardConfirmation ? <div className="alertSuccess"><i className="icon-check" />
                              <p>{this.props.eWalletCreatedMessage ? this.props.eWalletCreatedMessage : this.props.savedCardConfirmation ? this.props.savedCardConfirmation : null}</p>
                              <Link linkJSON={errorAncher} />
                            </div> : null
                            /* eslint-enable */
                          }
                          <span
                            className="title-confirmation"
                            style={{ paddingBottom: '5%' }}
                          >
                            Confirmación de retiro anticipado de mesa de regalos
                          </span>
                        </div>
                      </div>
                      {this.props.submitTransferenceData &&
                        <React.Fragment>
                          <div className="row">
                            <div className="col-xs-6">
                              <div className="date-verification">
                                <span>Fecha de operación &nbsp;</span>
                                <strong>
                                  {commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}
                                </strong>
                              </div>
                            </div>
                            <div className="col-xs-6">
                              {!this.props.printAndDownload ?
                                <div className="box-icons text-right">
                                  <Link rrLink={downloadFile} >
                                    <i className="iClass icon-descarga hover-icon" onClick={() => { this.props.getStatementDetailsForDownload(); }} aria-hidden="true" />
                                  </Link>
                                </div>
                              : null}
                            </div>
                          </div>
                          <VerificationPanel
                            user={this.props.user}
                            submitTransferenceData={this.props.submitTransferenceData}
                            loadFrom="partialConfirmation"
                            isEmployee={this.props.isEmployee}
                          />
                        </React.Fragment>}
                      {
                          this.props.isEmployee !== 'true' ?
                            <div className="box-description">
                              <p style={{ fontSize: '14px' }}>
                                {commonUtil.getLabel(this.props.lables['transference success page'], 'eventTransferences.success.message')}
                                {(this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== 'undefined' && this.props.submitTransferenceData.walletType == 'Monedero Digital') &&
                                <React.Fragment><br />{commonUtil.getLabel(this.props.lables['transference success page'], 'eventTransferences.dwallet.success.message')}</React.Fragment>
                          }
                              </p>
                            </div>
                      : null
                        }
                      <div className="box-instructions">
                        <p>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label1')} &nbsp;
                          <strong>{this.props.submitData.emailAddress}</strong>,&nbsp;
                          {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label2')}
                        </p>
                        {this.props.isEmployee !== 'true' ?
                          <p>
                            {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label3')}
                            <strong>
                              {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label4')}
                            </strong>
                          </p> :
                          <p>Conserva tu <strong>número de evento para el seguimiento.</strong></p>}

                      </div>
                      <div className="block-verification">
                        {this.props.submitData && this.props.submitData.enableSaveButton && this.props.submitData.enableSaveButton.toString() === 'true' ?
                          <div className="box-save-data row">
                            <div className="col-xs-8">
                              <p>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.savemessage')}</p>
                            </div>
                            <div className="col-xs-4 text-right save">
                              <InputButton buttonAttr={Guardar} />
                            </div>
                          </div> : null}
                      </div>
                      {!this.props.printAndDownload ?
                        <div className="row block-buttons">
                          <div className="col-xs-6 " />
                          <div className="col-xs-6 text-right">
                            <InputButton buttonAttr={eventAdministrationRedirect} />
                          </div>
                        </div> : null}
                    </div>
                  </div>
                </div>
              </div>}
          </React.Fragment>
          : null}
      </div>
    );
  }
}
